import { render, staticRenderFns } from "./mobile-MT4.vue?vue&type=template&id=4f7357b9&scoped=true&"
import script from "./mobile-MT4.vue?vue&type=script&lang=js&"
export * from "./mobile-MT4.vue?vue&type=script&lang=js&"
import style0 from "./mobile-MT4.vue?vue&type=style&index=0&id=4f7357b9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7357b9",
  null
  
)

export default component.exports